/***********************************************************/
/***********************************************************/
/* Vault Withdraw BSP Checkout Module   */
/***********************************************************/
/***********************************************************/

var vaultWithdrawBSPCheckoutModule = (function() {

  var url = '/checkout/bsp-withdrawal/',
    token = '',
    updateFlag,
    completionCheckCount = 0,
    completionCheckDelay = 0,
    costs = {
      paymentCost: '0',
      shippingCost: '0',
      insuranceCost: '0',
      storageFee: '0',
    },
    oldPaymentMethodIds = [],
    oldShippingMethodIds = [];

  /*
    DESC: Initialize vault withdraw checkout. USED IN: /vault/withdrawbsp
    POST /api/v1/vaultwithdrawcheckout/init
  */

  function init(cb) {
    var req = new Request(servicesUrl + url + 'init', {
      currency: getCurrency(),
      locationId: getLocation()
    });

    req.afterErrorDialogFunction(function(res) {
      if (res.cart == null) {
        window.location.href = '/myaccount/dashboard';
      }
    });

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res);
        sendComputeTaxes();
      }
    });

    req.call();
  }

  function updateCheckoutItems(res, currencyChanged) {

    // Redraw delivery dropdown

    var currentDeliveryID = $.map($('select[name=delivery] option'), function(option) {
      return option.value;
    });

    var newDeliveryID = $.map(res.shippingMethods, function(method) {
      return method.id;
    });

    // if(!arraysEqual(currentDeliveryID, newDeliveryID)) {
    // console.log('Delivery is not the Same!');
    // console.log('delivery element=' + $('#select-delivery-container').html());
    // console.log('delivery html=' + tmpl($('#tmpl-vault-bsp-checkout-select-delivery').html(), { obj: res }));
    $('#select-delivery-container').html(tmpl($('#tmpl-vault-bsp-checkout-select-delivery').html(), {
      obj: res
    }));
    // }

    $('select[name=delivery]').val(res.shippingMethodId);

    // Update shipping method
    $('.select-delivery-description').each(function() {
      var id = $(this).attr('data-id');
      for (var i = 0; i < res.shippingMethods.length; ++i) {
        if (res.shippingMethods[i].id == id) {
          if ($(this).html() != res.shippingMethods[i].description) {
            $(this).html(res.shippingMethods[i].description);
          }
        }
      }
    });

    // Redraw payment dropdown

    var currentPaymentID = $.map($('select[name=payment] option'), function(option) {
      return option.value;
    });

    var newPaymentID = $.map(res.paymentMethods, function(method) {
      return method.id;
    });

    if (!arraysEqual(currentPaymentID, newPaymentID)) {
      $('#select-payment-container').html(tmpl($('#tmpl-vault-checkout-select-payment').html(), {
        obj: res
      }));
    }

    $('select[name=payment]').val(res.paymentMethodId);
    oldPaymentMethodIds.push(res.paymentMethodId);
    oldShippingMethodIds.push(res.shippingMethodId);

    if (res.paymentMethods.length === 1) {
      $('select[name=payment]').addClass('hide');
    } else {
      $('select[name=payment]').removeClass('hide');
    }

    if (res.shippingMethods.length === 1) {
      $('select[name=delivery]').addClass('hide');
    } else {
      $('select[name=delivery]').removeClass('hide');
    }

    if (res.paymentRequired) {
      $('.payment-required').removeClass('hide');
    } else {
      $('.payment-required').addClass('hide');
    }

    // Table Fees Start
    $('.location-name').html(res.location.title);

    if (res.locations && res.locations.length < 2) {
      $('.change-storage-location').addClass('hide');
    } else if (res.locations && res.locations.length >= 2) {
      $('.change-storage-location').removeClass('hide');
    }

    if (res.requestLocation && res.requestLocation.id != res.location.id) {
      var options = {
        title: 'Withdraw Bullion Savings Program',
        message: 'You don\'t have any stored items available for withdrawal in ' + res.requestLocation.title + '. Location has been changed to ' + res.location.title + '.',
        okCallback: function() {}
      };
      var popup = new Popup(options);
      popup.render();
      setLocation(res.location.id, res.location.shortName);
    }

    if (res.costs.withdrawalCost) {
      $('.withrawal-fee-row').removeClass('hide');
      $('.withrawal-fee-row').find('.amount').text(res.costs.withdrawalCost);
    } else {
      $('.withrawal-fee-row').addClass('hide');
      $('.withrawal-fee-row').find('.amount').text('');
    }

    if (res.costs.withdrawalCostVat) {
      $('.withrawal-fee-vat-row').removeClass('hide');
      $('.withrawal-fee-vat-row').find('.amount').text(res.costs.withdrawalCostVat);
    } else {
      $('.withrawal-fee-vat-row').addClass('hide');
      $('.withrawal-fee-vat-row').find('.amount').text('');
    }

    if (res.costs.storageFee) {
      $('.storage-fee-row').removeClass('hide');
      $('.storage-fee-row').find('.amount').text(res.costs.storageFee);
    } else {
      $('.storage-fee-row').addClass('hide');
      $('.storage-fee-row').find('.amount').text('');
    }


    costs.shippingCost = res.costs.shippingCostPlain;
    costs.insuranceCost = res.costs.insuranceCostPlain;
    costs.paymentCost = res.costs.paymentCostPlain;
    costs.storageFeePre2023 = res.costs.storageFeePre2023Plain;
    costs.storageFee2023 = res.costs.storageFee2023Plain;
    costs.storageFee2024Onwards = res.costs.storageFee2024OnwardsPlain;

    // Table Fees End

    if (res.costs.storageFee === '') {
      // Hide Table Fees
      console.log('Hide Table Fees');
      $('.table-fees-wrap').removeClass('with-bg');
      $('.table-fees-wrap td:first-child, .table-fees-wrap td:last-child, .table-fees-wrap td .table-fees').addClass('no-padding-all');
      $('.table-fees-wrap td').addClass('no-border-bot');
    } else {
      $('.table-fees-wrap').addClass('with-bg');
      $('.table-fees-wrap td:first-child, .table-fees-wrap td:last-child, .table-fees-wrap td .table-fees').removeClass('no-padding-all');
      $('.table-fees-wrap td').removeClass('no-border-bot');
    }

    $('#delivery-cost').text(res.costs.shippingCost);

    if (res.costs.shippingCost) {
      $('.delivery-row').removeClass('hide');
      $('.delivery-row.value').text(res.costs.shippingCost);
    } else {
      if (res.shipping && getLocation() == 1 && getCountryCode() == 'SG') { // Apply only for Singapore
        $('.delivery-row').removeClass('hide');
        $('.delivery-row.value').text('FREE');
      } else {
        $('.delivery-row').addClass('hide');
        $('.delivery-row.value').text('');
      }
    }

    if (res.costs.insuranceCost) {
      $('.insurance-row').removeClass('hide');
      $('.insurance-row').find('.value').text(res.costs.insuranceCost);
    } else {
      $('.insurance-row').addClass('hide');
      $('.insurance-row').find('.value').text('');
      $('.insurance-vat-row').addClass('hide');
    }

    $('#payment-cost').text(res.costs.paymentCost);

    if (res.costs.paymentCost) {
      $('.payment-row.value').text(res.costs.paymentCost);
    } else {
      $('.payment-row.value').text('');
    }

    if (res.paymentRequired) {
      $('.withdraw-total-row td').addClass('no-padding-bot');
      $('.withdraw-total-row td').removeClass('padding-bot-10');
      $('.withdraw-total-row td:nth-child(1)').removeClass('bb-lr-20');
      $('.withdraw-total-row td:nth-child(4)').removeClass('bb-rr-20');
    } else {
      $('.withdraw-total-row td').addClass('padding-bot-10');
      $('.withdraw-total-row td:nth-child(1)').addClass('bb-lr-20');
      $('.withdraw-total-row td:nth-child(4)').addClass('bb-rr-20');
    }

    // Update input fields quantity if user enters more than available
    if (res.cart.metals.length) {
      var bullionIds = [];
      var allMetals = ['XAU', 'XAG', 'XPT'];
      var availableMetals = [];
      $.each(res.cart.metals, function(i, metal) {
        availableMetals.push(metal.metal);
        if (metal.error) {
          $('.error-msg-' + metal.metal).find('.required-bsp').addClass('font-red').text(metal.required);
        } else {
          $('.error-msg-' + metal.metal).find('.required-bsp').removeClass('font-red').text(metal.required);
        }
        $.each(metal.items, function(i, item) {
          bullionIds.push(item.productId);
          var $targetQty = $('.quantity[data-id=' + item.productId + ']');
          var $name = $targetQty.parents('tr').find('.bsp-product-name');
          if (item.quantityChanged) {
            $targetQty.val(item.quantity);
            $targetQty.attr('qty', item.quantity);
          }
          $name.text(item.title);
          if (item.preSaleDate.length) {
            $name.append('<br><span class="presale-date">' + item.preSaleDate + '</span>');
          }
          // $('.vault-quantity[data-id=' + item.productId + ']').text(item.vaultQuantity);
        })
      });

      // Remove Parents
      $.each(allMetals, function(i, metal) {
        if ($.inArray(metal, availableMetals) == -1) {
          $('.metal-' + metal).remove();
          $('.error-msg-' + metal).remove();
        }
      });

      // Remove non existing bullion
      $.each($('.checkout-table tbody .quantity'), function(i, el) {
        if ($.inArray($(this).data('id'), bullionIds) == -1) {
          $('.quantity[data-id=' + $(this).data('id') + ']').closest('tr').remove();
        }
      });
    } else {
      $('.checkout-table .item').remove();
      //$('.checkout-table > tbody').prepend(tmpl($('#tmpl-withdraw-cart-items-table').html(), { obj: res }));
    }

    token = res.priceLockToken;

    if (res.shipping) {
      $('.shipping').removeClass('hide');
      if (res.shippingCountries.length) {
        var options = '';
        var selected = '';
        var cc = []
        $.each(res.shippingCountries, function(i, country) {
          options += '<option value="' + country.code + '">' + country.name + '</option>';
          cc.push(country.code);
        });

        // Update country options and selection.
        var previousShippingCountry = $('#shipping-country').val();
        $('#shipping-country').html(options);

        if (cc.includes(res.shippingCountry)) {
          localStorage.setItem('shipping-country', res.shippingCountry);
          $('#shipping-country').val(res.shippingCountry);
          if (previousShippingCountry != res.shippingCountry) {
            $('#shipping-country').trigger('change');
          }
        }

        // Make sure to only have 1 #shipping-country selection
        var $parent = $('#shipping-country').parent();

        // Remove copy of selection on update that causes bug
        $parent.find('.country-selection-list').remove();

        // Update Selected Flag
        $parent.find('.flag').removeClass().addClass('flag flag-' + res.shippingCountry.toLowerCase());

        countrySelect('#shipping-country');
      }

      var countryName = $('#ship-to-another-address').is(':checked') ? $('#shipping-country').find('option:selected').text() : $('#country').find('option:selected').text();
      $('.shippingDestinationCountryAnchor').text(countryName);
    } else {
      $('.shipping').addClass('hide');
      $('#ship-to-another-address')[0].checked = false;
      $('.shipping-forms').addClass('hide');
    }

    loadCreditCard();

    vaultWithdrawCheckoutModule.termsTextSwitching(res);

    if (res.displayCreditCardFields) {
      var $ccNameField = $('input[data-input-type="creditcard-holder-name"]');
      var $ccNumberField = $('input[data-input-type="creditcard-number"]');
      var $ccCCVField = $('input[data-input-type="creditcard-exp-cvv"]');
      $('.credit-card-form').removeClass('hide');
      $('.with-card .cards-logo').removeClass('hide');
      if (!$ccNameField.val().length) $ccNameField.val(res.creditCardName).prev().addClass('active')
      if (cachedCCNumber) $ccNumberField.val(cachedCCNumber).trigger('input').prev().addClass('active');
      if (cachedCVV) $ccCCVField.val(cachedCVV).prev().addClass('active');
    } else {
      $('.credit-card-form').addClass('hide');
      $('.with-card .cards-logo').addClass('hide');
    }
  }

  function getCountryCode() {
    return getCountryCodeField().val();
  }

  function getCountryCodeField() {
    if ($('#ship-to-another-address').length && $('#ship-to-another-address').is(':checked')) {
      return $('#shipping-country');
    }

    if ($('#country').length > 0) {
      return $('#country');
    } else {
      return null;
    }
  }

  function generateTaxFormFields() {
    var countryCode = $('#ship-to-another-address').is(':checked') ? $('#shipping-country').val() : $('#country').val();

    var data = {
      priceLockToken: token,
      locationId: getLocation(),
      shippingMethodId: $('select[name=delivery]').val(),
      currency: getCurrency(),
      countryCode: countryCode,
      productsString: generateTaxProductString(),
      paymentCost: costs.paymentCost,
      shippingCost: costs.shippingCost,
      insuranceCost: costs.insuranceCost,
      storageFeePre2023: costs.storageFeePre2023,
      storageFee2023: costs.storageFee2023,
      storageFee2024Onwards: costs.storageFee2024Onwards
    }

    formValidationModule.addDataFromInputAndSelect(data, $('.user-form-info'), false, false);

    if ($('#ship-to-another-address').is(':checked')) {
      var shippingData = {};
      formValidationModule.addDataFromInputAndSelect(shippingData, $('.shipping-forms'), true, false);

      data.address1 = shippingData.shippingAddress1;
      data.address2 = shippingData.shippingAddress2;
      data.city = shippingData.shippingCity;
      data.postCode = shippingData.shippingPostCode;
      data.state = shippingData.shippingState;
      data.countryCode = shippingData.shippingCountryCode;
    }

    return data;
  }

  function sendComputeTaxes() {
    var data = generateTaxFormFields();

    var xhr = taxes(data, function(res) {
      updateCheckoutTaxItems(res);
    }, 1, false);
  }

  /*
    DESC: Get taxes buy checkout. USED IN: /buy/checkout page
    GET /checkout/buycheckout/taxes
  */
  function taxes(data, cb, noLoader, getXHR) {
    if (new Loading().isShowing()) {
      return null;
    }

    var req = new Request(servicesUrl + url + 'taxes', data);

    req.getXHR = getXHR || false;

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res);
      }
    });

    if (noLoader) {
      req.send();
    } else {
      req.call();
    }

    if (req.getXHR) {
      return req.xhr;
    }
  }

  function updateCheckoutTaxItems(res) {
    if (res.taxes.storageFeeVat) {
      $('.storage-fee-vat-row').removeClass('hide');
      $('.storage-fee-vat-row').find('.amount').text(res.taxes.storageFeeVat);
      $('.storage-fee-vat-row').find('.label').text(res.taxes.storageFeeTaxLabel);
      if (res.taxes.totalTaxLabel.length == 0 && res.taxes.storageFeeTaxLabel != 'Taxes') { // Combination
        $('.storage-fee-row-label').addClass('-italic');
        $('.storage-fee-row.value').addClass('-italic');
      } else {
        $('.storage-fee-row-label').removeClass('-italic');
        $('.storage-fee-row-value').removeClass('-italic');
      }
    } else {
      $('.storage-fee-vat-row').addClass('hide');
      $('.storage-fee-vat-row').find('.amount').text('');
    }

    if (res.taxes.shippingCostVat) {
      $('.delivery-vat-row-label').text(res.taxes.shippingTaxLabel);
      $('.delivery-vat-row.value').text(res.taxes.shippingCostVat);
      if (res.taxes.totalTaxLabel.length == 0 && res.taxes.shippingTaxLabel != 'Taxes') { // Combination
        $('.delivery-vat-row-label').addClass('-italic');
        $('.delivery-vat-row.value').addClass('-italic');
      } else {
        $('.delivery-vat-row-label').removeClass('-italic');
        $('.delivery-vat-row-value').removeClass('-italic');
      }
    } else {
      $('.delivery-vat-row-label').text('');
      $('.delivery-vat-row.value').text('');
    }

    if (res.taxes.insuranceCostVat) {
      $('.insurance-vat-row-label').text(res.taxes.insuranceTaxLabel);
      $('.insurance-vat-row').find('.value').text(res.taxes.insuranceCostVat);
      if (res.taxes.totalTaxLabel.length == 0 && res.taxes.insuranceTaxLabel != 'Taxes') { // Combination
        $('.insurance-vat-row-label').addClass('-italic');
        $('.insurance-vat-row.value').addClass('-italic');
      } else {
        $('.insurance-vat-row-label').removeClass('-italic');
        $('.insurance-vat-row-value').removeClass('-italic');
      }
    } else {
      $('.insurance-vat-row-label').text('');
      $('.insurance-vat-row').find('.value').text('');
    }

    if ($('.insurance-row').is(':visible')) {
      $('.insurance-vat-row').removeClass('hide');
    }

    if (res.taxes.paymentCostVat) {
      $('.payment-vat-row-label').text(res.taxes.paymentTaxLabel);
      $('.payment-vat-row.value').text(res.taxes.paymentCostVat);
      if (res.taxes.totalTaxLabel.length == 0 && res.taxes.paymentTaxLabel != 'Taxes') { // Combination
        $('.payment-vat-row-label').addClass('-italic');
        $('.payment-vat-row.value').addClass('-italic');
      } else {
        $('.payment-vat-row-label').removeClass('-italic');
        $('.payment-vat-row-value').removeClass('-italic');
      }
    } else {
      $('.payment-vat-row-label').text('');
      $('.payment-vat-row.value').text('');
    }

    $('#total').text(res.taxes.totalAmountToPay);

    if (res.taxes.totalVat && res.taxes.totalTaxLabel.length > 0) {
      $('.total-vat-row').removeClass('hide');
      $('.total-vat-row').find('.subtitle').text(res.taxes.totalTaxLabel);
      $('.total-vat-row').find('.value').text(res.taxes.totalVat);
    } else {
      $('.total-vat-row').addClass('hide');
      $('.total-vat-row').find('.value').text('');
    }

    if ($('.total-vat-row').is(':visible')) {
      $('.withdraw-total-row td:first-child').removeClass('bb-lr-20');
      $('.withdraw-total-row td:last-child').removeClass('bb-rr-20');
      $('.withdraw-total-row td:nth-child(2)').removeClass('title');
      $('.withdraw-total-row td:nth-child(3)').removeClass('last-amount');
      $('.withdraw-total-row td:nth-child(2)').removeClass('padding-bot-10');
      $('.withdraw-total-row td:nth-child(3)').removeClass('padding-bot-10');
      $('.total-vat-row td:first-child').addClass('bb-lr-20');
      $('.total-vat-row td:last-child').addClass('bb-rr-20');
    } else {
      $('.withdraw-total-row td:first-child').addClass('bb-lr-20');
      $('.withdraw-total-row td:last-child').addClass('bb-rr-20');
      $('.withdraw-total-row td:nth-child(2)').addClass('title');
      $('.withdraw-total-row td:nth-child(3)').addClass('last-amount');
      $('.withdraw-total-row td:nth-child(2)').addClass('padding-bot-10');
      $('.withdraw-total-row td:nth-child(3)').addClass('padding-bot-10');
      $('.total-vat-row td:first-child').removeClass('bb-lr-20');
      $('.total-vat-row td:last-child').removeClass('bb-rr-20');
    }
  }

  function sendUpdate(cb, getXHR, isLocationChanged, isCurrencyChanged) {
    var locationChange = isLocationChanged ? true : false;
    var currencyChanged = isCurrencyChanged ? true : false;
    var countryCode = $('#ship-to-another-address').is(':checked') ? $('#shipping-country').val() : $('#country').val();
    var data = {
      currency: getCurrency(),
      locationId: getLocation(),
      countryCode: countryCode,
      oldShippingMethodId: getOldShippingMethodId(oldShippingMethodIds),
      oldPaymentMethodId: getOldPaymentMethodId(oldPaymentMethodIds),
      paymentMethodId: $('select[name=payment]').val(),
      shippingMethodId: $('select[name=delivery]').val(),
      priceLockToken: token,
      productsString: locationChange ? '' : generateProductString()
    }

    var addtlData = {}
    formValidationModule.addDataFromInputAndSelect(addtlData, $('.user-form-info'), false, false);
    data.state = addtlData.state;

    if ($('#ship-to-another-address').is(':checked')) {
      var shippingData = {};
      formValidationModule.addDataFromInputAndSelect(shippingData, $('.shipping-forms'), true, false);

      data.shippingName = shippingData.shippingName;
      data.shippingState = shippingData.shippingState;
      data.shippingCountryCode = shippingData.shippingCountryCode;
    }

    var xhr = update(data, function(res) {
      updateCheckoutItems(res, currencyChanged);
      typeof cb === 'function' && cb();
    }, 1, getXHR);

    if (getXHR) {
      return xhr;
    }
  }

  function loadPage(res) {
    $('.currency-wrap .radio-one-line input, .change-currency').off('click');

    $('.vault-checkout-wrap').html(tmpl($('#tmpl-vault-withdraw-bsp-checkout-payment').html(), {
      obj: res
    }));

    $.each(res.additionalCountries, function(i, country) {
      $('.country-select').prepend('<option value="' + country.countryCode + '">' + country.countryName + '</option>');
      $('.country-code-selection').prepend('<option value="' + country.countryCode + '" data-country="' + country.countryCodeLC + '" data-country-name="' + country.countryName + '" data-code="' + country.phoneCode + '">+' + country.phoneCode + ' ' + country.countryName + '</option>');
    });

    initLandCode('#country-code-selection');

    // Used to remember what is the selected shipping country on update, but we remove it on load
    localStorage.removeItem('shipping-country');

    // if(detectIE() || isFirefox()) {
    //   $('.txt-pin-code').attr('type', 'password');
    // }

    // Customer Info
    accountModule.setDetails(res.address);
    $('.customer-info .country').html('<br/>' + $('#country option:selected').text());
    $('.customer-info .phone-number').html('<br/> +' + $('#country-code-selection option:selected').data('code') + ' ' + res.address.phoneNumber);

    updateCheckoutItems(res);

    $('#header-location').on('change', function() {
      sendUpdate(null, false, true);
    });

    $('.change-storage-location').on('click', function() {
      var popup = new PopupStorageLocation(res.locations);
      popup.render();
    });

    // Removed since changing details now is a link to /myaccount/details
    //countrySelect('#country');

    // if(localStorage.getItem('checkout-country') !== null) {
    //   $('#country').val(localStorage.getItem('checkout-country')).trigger('change');
    //   $('.customer-info .info .country').html('<br/>' + $('#country option:selected').text());
    // }

    // Removed since changing details now is a link to /myaccount/details
    // Country changed
    // $('#country').on('change', function() {
    //   sendUpdate();
    //   //localStorage.setItem('checkout-country', $(this).val());
    // });

    $('.shipping-forms input, .shipping-forms select').on('change', debounce(function() {
      sendUpdate();
    }, 300));

    // Delivery clicked
    $('.wrap-body').on('change', 'select[name=delivery]', function() {
      var $selectedOption = $('select[name=delivery] option:selected');

      $('.select-delivery-description').addClass('hide');
      $('.select-delivery-description[data-id=' + $selectedOption.val() + ']').removeClass('hide');

      if (typeof updateFlag === 'object') {
        updateFlag.abort();
      }
      updateFlag = sendUpdate(null, true);
    });

    // Payment clicked
    $('.wrap-body').on('change', 'select[name=payment]', function() {
      var $selectedOption = $('select[name=payment] option:selected');

      $('.select-payment-description').addClass('hide');
      $('.select-payment-description[data-id=' + $selectedOption.val() + ']').removeClass('hide');

      if ($selectedOption.attr('data-currency')) {
        changeCurrency($selectedOption.data('currency'));

        if (typeof updateFlag === 'object') {
          updateFlag.abort();
        }
        updateFlag = sendUpdate(null, true, false, true);
      } else {
        if (typeof updateFlag === 'object') {
          updateFlag.abort();
        }
        updateFlag = sendUpdate(null, true);
      }

      // if(!$selectedOption.attr('data-currency')) {
      //   if(typeof updateFlag === 'object') {
      //     updateFlag.abort();
      //   }
      //   updateFlag = sendUpdate(null, true);
      // } else {
      //   console.log('Change Currency');

      //   if(getCurrency() !== $selectedOption.data('currency')) {
      //     var cryptoCur = $selectedOption.text();
      //     var options = {
      //       title: generateChangeCryptoCurrencyTitle(cryptoCur),
      //       message: generateChangeCryptoCurrencyMessage(cryptoCur),
      //       okCallback: function() {
      //         changeCurrency($selectedOption.data('currency'));

      //         if(typeof updateFlag === 'object') {
      //           updateFlag.abort();
      //         }
      //         updateFlag = sendUpdate(null, true, false, true);
      //       }
      //     };

      //     var popup = new Popup(options);
      //     popup.render();
      //   }
      // }
    });

    $('.currency-wrap .radio-one-line input').on('click', debounce(function() {
      var _this = $(this),
        value = _this.val();

      if (getCurrency() !== value) {
        //$('.vault-checkout-wrap .payment').empty();
        changeCurrency(value);

        if (typeof updateFlag === 'object') {
          updateFlag.abort();
        }
        updateFlag = sendUpdate(null, true, false, true);

        headerCurrencyChange();
      }
    }, 300));

    $('#payment-change-currency').on('click', function() {
      var popupCurrency = new PopupCurrency();
      popupCurrency.render();
    });

    // $('.wrap-body').on('click', '.change-currency', function() {
    //   var _this = $(this),
    //       value = _this.data('currency');

    //   if(getCurrency() !== value) {
    //     var options = {
    //       title: 'Currency Changed to Bitcoin',
    //       message: 'Please note that the currency has been changed to Bitcoin.',
    //       okCallback: function() {
    //         $('.vault-checkout-wrap .payment').empty();
    //         changeCurrency(value);
    //         //$('.currency-wrap .radio-one-line input[value="' + getCurrency() + '"]').prop('checked', true);

    //         setTimeout(function() {
    //           sendUpdate();
    //         }, 300);
    //       }
    //     };

    //     var popup = new Popup(options);
    //     popup.render();
    //   }
    // });

    // Change value
    $('.vault-checkout-wrap .quantity').on('change', debounce(function() {
      handleChange($(this).data('id'), false);
    }, 300));

    $('.vault-checkout-wrap .quantity').on('keyup', debounce(function(e) {
      if (isKeycodeNumber(e)) {
        handleChange($(this).data('id'), false);
      }
    }, 300));

    $('#btn-place-order').on('click', function(e) {
      formValidationModule.validateForm($('.vault-checkout-wrap'), 'Withdraw BSP', function(data) {
        data.cardExpMonth = $('#credit-card-exp-mm').val();
        data.cardExpYear = $('#credit-card-exp-yy').val();
        data.locationId = getLocation();
        data.currency = getCurrency();
        data.paymentMethodId = $('select[name=payment]').val();
        data.shippingMethodId = $('select[name=delivery]').val();
        data.productsString = generateProductString();
        data.phoneCountry = $('#country-code-selection').val();
        data.countryCode = $('#country').val();
        data.priceLockToken = token;
        data.locationId = getLocation();
        data.ct = getCT();

        formValidationModule.addData(data, $('.user-form-info'), false);

        if ($('#ship-to-another-address').is(':checked')) {
          formValidationModule.addData(data, $('.shipping-forms'), false);
        }

        if (validateAgreeCheckboxes('Withdraw Bullion Savings Program')) {
          confirm(data);
        }
      }, null, true);
    });

    // Toggle shipping address
    $('#ship-to-another-address').on('change', function() {
      $('.shipping-forms').toggleClass('hide');
      checkoutCountryChange($('.shipping-forms'));
      sendUpdate();
    });
  }

  /*
    DESC: Update vault withdraw checkout. USED IN: /vault/withdrawbsp page
    GET /api/v1/vaultwithdrawcheckout/update
    productsString:1106
    currency:SGD
    countryCode:SG
    shippingMethodId:3
    paymentMethodId:13
  */
  function update(data, cb, noLoader, getXHR, cancelCb) {
    if (new Loading().isShowing()) {
      return null;
    }

    var req = new Request(servicesUrl + url + 'update', data);

    //req.useRequestId(true);
    req.getXHR = getXHR || false;

    req.afterErrorDialogFunction(function(res) {
      if (res.cart == null) {
        window.location.href = '/myaccount/dashboard';
      }
    });

    req.afterSuccessDialogFunction(function(res) {
      if (res.displayCreditCardFields) {
        $('input[data-input-type="creditcard-number"]').prev().trigger('click');
      }
    })

    req.afterWarningCancelDialogFunction(function(res) {
      typeof cancelCb === 'function' && cancelCb(res);
    });

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res);
        sendComputeTaxes();
      }
    });

    if (noLoader) {
      req.send();
    } else {
      req.call();
    }

    if (req.getXHR) {
      return req.xhr;
    }
  }

  /*
    DESC: Confirm vault withdraw checkout. USED IN: /vault/withdrawbsp page
    GET /api/v1/vaultwithdrawcheckout/confirm
    productsString:1106
    currency:SGD
    shippingMethodId:3
    paymentMethodId:13
    email:
    name:
    phoneCountry
    company:test
    address1:Marina Bay Financial Center
    address2:Level 39, 10 Marina Boulevard
    city:Santa rosa
    state:
    postCode:4412
    countryCode:SG
  */
  function confirm(data) {

    data.machineId = getMachineId();
    data.sessionId = sessionModule.getSessionId();
    var req = new Request(servicesUrl + url + 'confirm', data);

    req.afterErrorDialogFunction(function(res) {
      if (res.accountLocked) {
        authenticationModule.logout();
        return;
      }
      formValidationModule.showError('.vault-checkout-wrap', res.errorParameter);
    });

    req.afterWarningDialogFunction(function(res) {
      req.send(true);
    })

    req.success(function(res) {
      if (res.transactionId && res.transactionId != '') {
        waitForCompletion(req, res.transactionId);
      } else {
        req.hideLoader();
        updateCheckoutItems(res);
        sendComputeTaxes();
      }
    });

    req.dontHideLoaderOnSuccess(true);
    req.call();
  }

  function waitForCompletion(confirmReq, transactionId) {
    completionCheckCount = 0;
    completionCheckDelay = 500;

    setTimeout(checkForCompletion, completionCheckDelay, confirmReq, transactionId);
  }

  /*
    DESC: Check for completion status of a submitted order. USED IN: checkout page
    transactionId:1234-1234-1234-1234
  */
  function checkForCompletion(confirmReq, transactionId) {
    completionCheckCount++;
    if (completionCheckCount > 200) {
      completionCheckDelay = 3000;
    } else if (completionCheckCount > 50) {
      completionCheckDelay = 1000;
    } else {
      completionCheckDelay = 500;
    }

    new Request(servicesUrl + url + 'status', {
        transactionId: transactionId
      })
      .error(function(json) {
        confirmReq.hideLoader();
        var popup = new Popup({
          title: json.title,
          message: json.message
        });
        popup.render();
      }).success(function(json) {
        if (json.url && json.url != '') {
          window.location.href = json.url;
        } else if (json.stockChanges) {
          sendUpdate();
        } else {
          setTimeout(checkForCompletion, completionCheckDelay, confirmReq, transactionId);
        }
      }).send();
  }

  var quantityTimer = null;

  function handleChange(productId, delay) {
    if (delay) {
      if (quantityTimer != null) {
        clearTimeout(quantityTimer);
        quantityTimer = null;
      }
      quantityTimer = setTimeout(vaultWithdrawBSPCheckoutHandleChange, 200, productId);
    } else {
      var _this = $('.quantity[data-id=' + productId + ']');

      if (!_this.length) return;

      var quantityString = _this.val();
      quantityString = quantityString.trim();
      if (quantityString.length == 0) {
        quantityString = '0';
      }

      var quantity = parseInt(quantityString, 10);
      if (!isNaN(quantity)) {
        _this.attr('qty', quantity);

        if (typeof updateFlag === 'object') {
          updateFlag.abort();
        }
        console.log('handleChange');
        updateFlag = sendUpdate(null, true);
      }
    }
  }

  function generateProductString() {
    var str = '';

    $('.vault-checkout-wrap .quantity').each(function() {
      var productId = $(this).attr('data-id');
      var quantity = parseInt($(this).val());
      if (isNaN(quantity)) {
        quantity = $(this).attr('qty');
      }
      if (str.length > 0) {
        str += ',';
      }
      str += productId + ',' + quantity;
    });

    return str;
  }

  function generateTaxProductString() {
    var str = '';

    $('.vault-checkout-wrap .quantity').each(function() {
      var productId = $(this).attr('data-id');
      var quantity = parseInt($(this).val());
      if (isNaN(quantity)) {
        quantity = $(this).attr('qty');
      }

      if (quantity > 0) {
        if (str.length > 0) {
          str += ',';
        }

        str += productId + '#' + quantity + '#0';
      }
    });

    return str;
  }

  return {
    init: init,
    loadPage: loadPage,
    update: update,
    handleChange: handleChange,
    confirm: confirm,
    generateProductString: generateProductString
  }
}());

function vaultWithdrawBSPCheckoutHandleChange(productId) {
  vaultWithdrawBSPCheckoutModule.handleChange(productId, false);
}

/* Add for mocha testing */
// Basically it make the vaultWithdrawCheckoutModule nodejs module compatible
if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = vaultWithdrawBSPCheckoutModule;
}